import React, { useMemo } from 'react';

interface MultiTextInputSuggestionItemProps {
  valid: boolean;
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function MultiTextInputSuggestionItem({ children, valid, onClick }: MultiTextInputSuggestionItemProps) {
  const backgroundColor = useMemo(() => {
    if (!valid) return 'bg-error-200';

    return 'bg-success-200 hover:bg-success-300';
  }, [valid]);

  const cursor = useMemo(() => {
    if (!valid) return 'cursor-not-allowed';

    return 'cursor-pointer';
  }, [valid]);

  return (
    <div className={`px-3 py-2 ${backgroundColor} ${cursor}`} onClick={onClick} role='option'>
      {children}
    </div>
  );
}

interface DefaultMultiTextInputSuggestionProps {
  value: string;
  leading?: React.ReactNode;
  helpText?: string;
}

export function DefaultMultiTextInputSuggestion({ value, leading, helpText }: DefaultMultiTextInputSuggestionProps) {
  return (
    <div className='flex min-w-fit items-center gap-1 stroke-black text-sm font-normal'>
      {leading && leading}
      {helpText && <p className='select-none text-black'>{helpText}</p>}
      <p className='text-gray-700'>{value}</p>
    </div>
  );
}
